import React, {useState} from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from "react-bootstrap/Container";
import cx from "classnames";

import {Alert, AlertTitle, Button} from "@mui/material";
import styles from './CookieNotification.module.scss';

import CloseFilled from '../../../static/icons/close-filled.svg';

function CookieNotification() {

    const cookies = document.cookie.split(';').some((item) => item.trim().startsWith('cookiesAccepted=')) === true;

    const [showNotification, setShowNotification] = useState(!cookies);

    const handleAccept = () => {
        document.cookie = "cookiesAccepted=true; path=/; max-age=31536000";
        setShowNotification(false);
    }

    if (!showNotification) return null;

    return (
        <Container className={styles.notification}>
            <Alert severity="info">
                <Row className="justify-content-between align-items-center m-0">
                    <Col xs={11} md={9} lg={10} xxl={8} className="p-0">
                        <div className={styles.alertInfo}>
                            <div className={styles.alertText}>
                                <AlertTitle>Мы&nbsp;используем cookies для быстрой и&nbsp;удобной работы сайта</AlertTitle>
                                <p className={styles.text}>
                                    Продолжая пользоваться сайтом, вы&nbsp;соглашаетесь с этим.
                                </p>
                            </div>
                        </div>
                        <div className={styles.closeButtonContainerSmall}>
                            <img src={CloseFilled} alt="" className={styles.cross} onClick={handleAccept}/>
                        </div>
                    </Col>
                    <Col xs={4} md={3} lg={2} className={cx(styles.closeButtonContainerBig, "p-0")}>
                        <Button variant="outlined" className={styles.button} onClick={handleAccept}>
                            <img src={CloseFilled} alt="" className={styles.cross}/>
                            Закрыть
                        </Button>
                    </Col>
                </Row>
            </Alert>
        </Container>
    );
}

export default CookieNotification;
